import React from 'react';
import { connect } from 'react-redux';
import ProjectLayoutView from '../view/ProjectLayoutView';

class ProjectLayout extends React.Component {
	render() {
		return (
			<ProjectLayoutView
				productName={this.props.productName}
				projectName={this.props.projectName}
				fullscreen={this.props.fullscreen}
				hasNav={this.props.hasNav}
			>
				{this.props.children}
			</ProjectLayoutView>
		);
	}
}

function mapStateToProps(state) {
	return {
		productName: (state.system && state.system.config && state.system.config.productName) || '',
		projectName: (state.project && state.project.project && state.project.project.name) || ''
	};
}

export default connect(
	mapStateToProps
)(ProjectLayout);
